import { UploadTabController } from './upload-tab.controller'

function uploadTab () {
  return {
    scope: {
    },
    restrict: 'E',
    templateUrl: '/repository/directives/upload-tab/upload-tab.html?$$REVISION$$',
    controller: UploadTabController
  }
}

export { uploadTab }
